import React from 'react';
import { TRUST_PILLARS } from '../data/copy';

/**
 * 4 brand pillars under the home hero:
 *   High Quality / Competitively Priced / Scale / Experience
 *
 * Even-indexed numerals render gold, odd-indexed blue (01 gold, 02 blue,
 * 03 gold, 04 blue) per the brand tuning pass.
 *
 * Intro line above the pillars surfaces the authentic Centurion positioning
 * for owners, contractors, and First Nations groups.
 */
export const TrustPillars = () => (
    <section
        className="border-y border-brand-hairline bg-brand-surface"
        data-testid="trust-pillars"
    >
        <div className="mx-auto max-w-7xl px-6 py-14 md:px-10 md:py-16">
            <h2
                className="font-display text-base font-bold uppercase tracking-[0.18em] text-brand-text"
                data-testid="trust-pillars-title"
            >
                Protecting the Ground. Providing Safe Access.
            </h2>
            <span
                aria-hidden="true"
                className="mt-4 block h-px w-12 bg-brand-gold"
            />
            <p
                className="mt-6 max-w-3xl font-sans text-base leading-relaxed text-brand-muted"
                data-testid="trust-pillars-intro"
            >
                Centurion supplies owners, contractors, and First Nations groups with
                quality and custom-built matting solutions delivered on schedule and on
                budget.
            </p>
            <div className="mt-12 grid gap-px bg-brand-hairline md:grid-cols-2 lg:grid-cols-4">
                {TRUST_PILLARS.map((p, i) => {
                    const isBlue = i % 2 === 1;
                    return (
                        <div
                            key={p.head}
                            className="bg-brand-surface p-6 md:p-8"
                            data-testid={`trust-pillar-${i}`}
                        >
                            <span
                                className={[
                                    'font-display text-xs font-bold tabular-nums tracking-[0.2em]',
                                    isBlue ? 'text-brand-blue' : 'text-brand-gold',
                                ].join(' ')}
                            >
                                0{i + 1}
                            </span>
                            <h3 className="mt-5 font-display text-lg font-bold uppercase tracking-tight text-brand-text">
                                {p.head}
                            </h3>
                            <p className="mt-3 font-sans text-sm leading-relaxed text-brand-muted">
                                {p.body}
                            </p>
                        </div>
                    );
                })}
            </div>
        </div>
    </section>
);

export default TrustPillars;
